const yhjRouter =
[
  {
    path: '/couponHome',
    component: () => import('@/views/yhj/home/index.vue'),
    meta: {
      title: '社群优惠券',
      content: {
        // keywords: '',
        description: '全场通用社群优惠券，名额有限，限时领取'
      }
    }
  },
  {
    // 支付页面
    path: '/epay',
    name: 'Epay',
    component: () => import('@/views/yhj/ePay/index')
  },
  {
    path: '/paySucess',
    name: 'paySucess',
    component: () => import('@/views/yhj/ePay/paySucess')
  },
  {
    path: '/getCoupon',
    name: 'GetCoupon',
    component: () => import('@/views/yhj/home/index'),
    meta: {
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    }
  },
  {
    path: '/getCoupon1',
    name: 'GetCoupon1',
    component: () => import('@/views/yhj/home/other_get'),
    meta: {
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    }
  },
  {
    path: '/getSuccess',
    name: 'GetSuccess',
    // component: () => import('@/views/getCoupon/getSuccess')
    component: () => import('@/views/yhj/home/success')
  },
  // 已领取页面
  {
    path: '/alreadyReceived',
    name: 'AlreadyReceived',
    component: () => import('@/views/yhj/home/alreadyReceived')
  },
  {
    // 支付页面
    path: '/give',
    name: 'Give',
    component: () => import('@/views/yhj/give/index'),
    meta: {
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    }
  }
]

export default yhjRouter

